import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageVisit, trackProgramPageVisit } from "../utils/analytics";

// Simple analytics hook for automatic page tracking
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const search = location.search;
    const fullPath = path + search;

    // Get page name from path
    let pageName = "Home";
    if (path === "/") {
      pageName = "Home";
    } else if (path.startsWith("/programs/")) {
      const programName = path.split("/")[2];
      pageName = programName.charAt(0).toUpperCase() + programName.slice(1);

      // Track program page visit
      trackProgramPageVisit(pageName, fullPath);
    } else if (path.startsWith("/about")) {
      pageName = "About";
    } else if (path.startsWith("/careers")) {
      pageName = "Careers";
    } else if (path.startsWith("/pricing")) {
      pageName = "Pricing";
    } else if (path.startsWith("/terms")) {
      pageName = "Terms and Conditions";
    } else {
      // Extract page name from path
      pageName = path.split("/").pop().replace(/-/g, " ");
      pageName = pageName.charAt(0).toUpperCase() + pageName.slice(1);
    }

    // Track general page visit
    trackPageVisit(pageName, fullPath);
  }, [location]);
};

// Export the hook
const analyticsHooks = {
  usePageTracking,
};

export default analyticsHooks;
